module.exports = __webpack_public_path__ + "static/media/arrow-collapse.f686901e.svg";